import { render, staticRenderFns } from "./TgTrialBtn.vue?vue&type=template&id=34dc051e"
import script from "./TgTrialBtn.vue?vue&type=script&lang=js"
export * from "./TgTrialBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports